<template>
  <div class="hy-index">
    <userinfo></userinfo>
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title active" style="margin-bottom:10px;">
            我的活动
           <van-dropdown-menu>
             <van-dropdown-item v-model="value1" :options="option1" @change="changeType"/>
           </van-dropdown-menu>
        </h5>
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="item in tuiList" :key="'key_'+item.a_id">
              <div class="imgbox">
                <router-link class="nav-link" :to="'/orderDetails/'+item.order_no">
                <img :src="item.cover_url" alt />
                <span class="text_icon" v-if="item.status_str == '待发布'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.status_str == '已发布' || item.status_str == '报名中'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '会议中'">{{item.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.status_str == '已结束'">{{item.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.status_str == '未到报名时间'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.status_str == '报名截止'">{{item.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.status_str}}</span>
                <!-- <span class="text_icon icon_black">已结束</span> -->
                <!-- <span class="text_icon icon_blue">活动中</span> -->
                </router-link>
              </div>
              <div class="textbox">
                <div class="title">
                  <router-link class="nav-link" :to="'/orderDetails/'+item.order_no">
                  <h5>{{item.name}}</h5>
                  <span class="type" v-if="item.type == 1">会议</span>
                  <span class="type" v-else-if="item.type == 2">沙龙</span>
                  <span class="type" v-else-if="item.type == 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                  </router-link>
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{item.start_time,'Y-M-D'|formatDates}}~{{item.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{item.region}}&nbsp;{{item.specific_address}}
                </div>
                <div class="btnbox">
                  <a class="nav-link blue" v-if="item.jump_page == 1" :href="'/index/Conference/template?id='+item.id"><span class="text">会议首页</span></a>
                  <router-link class="nav-link blue" v-else-if="item.jump_page == 2" :to="'/info/'+item.id"><span class="text">会议首页</span></router-link>
                  <router-link class="nav-link blue" v-else-if="item.jump_page == 3" :to="'/shares/1?id='+item.id"><span class="text">会议首页</span></router-link>

                  <router-link class="nav-link" :to="'/orderInfo/'+item.order_no"><span class="text">我的会议信息</span></router-link>
                  <router-link class="nav-link" :to="'/orderDetails/'+item.order_no"><span class="text">查看订单</span></router-link>
                  <a class="nav-link blue" v-if="item.order_status == 'finished'"  @click.stop="backMoney(item)" >申请退款</a>
                </div>
              </div>

          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
   <!--   <div class="hy-fixed-userBtn">
        <router-link class="iconfont fixed-link" to="/">&#xe60e;</router-link>
      </div>-->
     <van-dialog v-model="tuikuan" title="温馨提示" show-cancel-button :before-close="CloseKa">
      <div class="tuikuan_tips" v-if="tuiData?.refund_reminder != ''">
        {{tuiData?.refund_reminder}}
      </div>
      <van-field v-model="tuiText" label="" placeholder="请输入退款原因" class="kaInput" v-else/>
    </van-dialog>
      </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
    import userinfo from '@/components/common/userinfo'
  export default {
    components:{
      userinfo
    },
    data() {
      return {
        option1: [
          { text: '全部会议', value: 0 },
          { text: '会议', value: 1 },
          { text: '活动', value: 2 },
          { text: '沙龙', value: 3 }
        ],
        value1:0,
        moreText:'没有更多了',
        searchValue: "",
        tuiList: [],
        loading: false,
        finished: false,
        page: 0,
        pagesize: 10,

        tuikuan:false,
        tuiText:'',
        tuiData:null,
      };
    },
    created() {
      var _this = this;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });

    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      /* 初始化数据列表 */
      onLoad(page, pagesize) {
        var _this = this;
        let url = "/ac1/conference/myEnroll";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
          type:_this.value1,
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            // 加载状态结束
            _this.loading = false;
            if (res.posts.data.length < _this.pagesize) {
              _this.finished = true;
              if(_this.page == 1 && res.posts.data.length == 0){
                _this.moreText = '暂无内容';
              }
            }
            res.posts.data.forEach(v => {
              _this.tuiList.push(v);
            });
            _this.page = _this.page + 1;
          }else{
            _this.$toast(res.msg);
          }
        },function(res){
          console.log(res.msg);
        });
      },
      changeType(){
        var _this = this;
        _this.tuiList = [];
        _this.page =1;
        _this.moreText = '没有更多了';
        _this.finished = false;
      },
        //退款
    backMoney(data){
      var _this =this;
       _this.tuiText = '';
      _this.tuiData = data;
      _this.tuikuan = true;
    },
    async  CloseKa(action, done){
        var _this =this;
        if(action == 'confirm'){
          if(_this.tuiText == '' && _this.tuiData?.refund_reminder == ''){
            _this.$toast('退款原因不能为空！')
            done(false); 
            return false;
          } 
          let url = "/ac1/conference/refund";//退款原因
            let params = {
              order_on:_this.tuiData.order_no,
              reason:_this.tuiText
            };
          _this.$post(url, params).then(res => {
            _this.tuikuan = false;
              if (res.code == "1") {
                _this.$toast('您的退款信息已提交，您的退款申请小编已经进入审核！'); 
              }else{
                _this.$toast(res.msg);
                done();
              }
            },function(res){
              console.log(res.msg);
            });
        } 
        if(action == 'cancel'){
          done();
        }
      },
    }
  };
</script>
<style lang="less" scoped>
   /deep/ .btnbox{
      width: 100%;
      display: flex;
      padding-top: 20px;
      a{
        display: block;
        flex: 1;
        overflow: hidden;
        text-align: center;
        &.blue{
          color: #1994fb;
        }
        &.yellow{
          color: #fe6333;
        }
        &.hui{
          color: #999;
        }
      }
    }
 .tuikuan_tips{
    width: 100%;
    padding: 30px;
    font-size: 28px;
    color: #ee0a24;
  }
  .kaInput{
    width: 100%;
    input{
      width: 100%;
      height: 70px;
      line-height: 70px;
      margin: 20px 0px;
      text-align: left;
      border: 1px solid #f1f1f1;
      font-size: 30px;
      padding: 0 10px;
    }
  }
</style>
